import { FolderAddOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { useAppDispatch } from "../../../../hooks/use-app-dispatch.ts"
import { createReportFolder } from "../../redux/reports.thunks.ts"
import { ReportFolderNameModal } from "./ReportFolderNameModal.tsx"

interface NewFolderButtonProps {
  existing: string[]
  /** The folder was saved; the host files the report it is editing there. */
  onCreated: (name: string) => void
}

/** Creates a real, saved folder from inside a form, without leaving it. */
export const NewFolderButton = ({
  existing,
  onCreated
}: NewFolderButtonProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [open, setOpen] = useState(false)

  const submit = async (name: string): Promise<string | null> => {
    const action = await dispatch(createReportFolder({ name }))
    if (!createReportFolder.fulfilled.match(action))
      return action.payload?.message ?? ""
    onCreated(action.payload)
    return null
  }

  return (
    <>
      <Button
        type="link"
        icon={<FolderAddOutlined aria-hidden />}
        className="shrink-0 px-1"
        onClick={() => setOpen(true)}
      >
        {t("reports.folders.newFolder")}
      </Button>
      {open && (
        <ReportFolderNameModal
          mode="create"
          existing={existing}
          onSubmit={submit}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
